var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopUniversities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17263",
    "data-name": "Group 17263",
    transform: "translate(19729 15790)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "university_1_",
    "data-name": "university (1)",
    transform: "translate(-19727 -15788.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8324",
    "data-name": "Path 8324",
    d: "M93.271,3.792,89.458,2.635V2.129h1.824a.406.406,0,0,0,.36-.235.483.483,0,0,0,.048-.173.493.493,0,0,0-.107-.343l-.189-.243a.077.077,0,0,1,0-.1L91.559.86a.481.481,0,0,0,.105-.478.473.473,0,0,0-.023-.055.406.406,0,0,0-.36-.234H89.048a.432.432,0,0,0-.41.451v2.1L84.847,3.792Z",
    transform: "translate(-82.76)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8325",
    "data-name": "Path 8325",
    d: "M12.679,183.04a.121.121,0,0,0-.119-.145H.2a.122.122,0,0,0-.119.145,1.816,1.816,0,0,1,0,.675.122.122,0,0,0,.119.145H12.56a.122.122,0,0,0,.119-.145A1.814,1.814,0,0,1,12.679,183.04Z",
    transform: "translate(-0.081 -178.306)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8326",
    "data-name": "Path 8326",
    d: "M12.262,260.189h-.316v-5.663H9.458v5.663h-.8v-5.663H4v5.663h-.8v-5.663H.657v5.663H.337a.337.337,0,0,0,0,.674H12.262a.337.337,0,0,0,0-.674Zm-1.567-4.719a.4.4,0,1,1-.4.4A.4.4,0,0,1,10.695,255.469Zm0,1.635a.4.4,0,1,1-.4.4A.4.4,0,0,1,10.695,257.1Zm0,1.635a.4.4,0,1,1-.4.4A.4.4,0,0,1,10.695,258.739ZM1.9,255.469a.4.4,0,1,1-.4.4A.4.4,0,0,1,1.9,255.469Zm0,1.635a.4.4,0,1,1-.4.4A.4.4,0,0,1,1.9,257.1Zm0,1.635a.4.4,0,1,1-.4.4A.4.4,0,0,1,1.9,258.739Zm3.235-3.249H7.468a.4.4,0,0,1,0,.8H5.135a.4.4,0,0,1,0-.8Zm1.9,4.7V258.7a.738.738,0,1,0-1.476,0v1.486h-.8V258.7a1.535,1.535,0,1,1,3.07,0v1.486Z",
    transform: "translate(0 -248.174)",
    fill: "#f9b316"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2240",
    "data-name": "Rectangle 2240",
    width: 16,
    height: 16,
    transform: "translate(-19729 -15790)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopUniversities);
export default __webpack_public_path__ + "static/media/top_universities.7e0c7e328a809163974e2714400ddfc9.svg";
export { ForwardRef as ReactComponent };